<app-etapas *ngIf="inicioCapacitacion">
</app-etapas>
<div class="customers" *ngIf="!inicioCapacitacion">

    <div class="card">
        <div class="card-body" style="padding: 20px;">

            <div class="row">
                <div class="col-sm-6 text-align-right">
                    <div class="image-title">
                        <img src="../../../../../assets/icons/01-capacitacion.png" alt="avatar" class="stage-icon">
                    </div>
                </div>

                <div class="col-sm-6 text-align-right state-text">
                    <p style="font: normal normal 600 14px/18px Montserrat;
                        letter-spacing: 0px;
                        color: #30374B;
                        text-transform: uppercase;
                        display: inline-block;
                        opacity: 1;">Estado de Capacitación:</p>
                    <div style="display: inline-block;
                        background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        margin-left: 15px;">
                        <p class="textoEstado1" *ngIf="status == 'No iniciada'">No iniciado</p>
                        <p class="textoEstado2" *ngIf="status == 'En progreso'">En curso</p>
                        <p class="textoEstado3" *ngIf="status == 'Finalizado'">Finalizada</p>

                    </div>
                </div>
                <!-- 
            <div class="row">
                <div class="col-sm-12">
                    <p style="text-align: left;
                        font: normal normal bold 26px/53px Montserrat;
                        letter-spacing: 0px;
                        color: #00B09E;
                        opacity: 1;">Etapa 1: Capacitación</p>


                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;"><b>Lo sentimos.</b></p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">Esta sección estará disponible de acuerdo a la etapa del proceso que se encuentre transitando su unidad educativa.</p>
                </div>
                
            </div>
            <div class="row">
                <div class="col-sm-12" style="text-align: center;">
                    <img src="../../../../../assets/icons/404-wip_1.png" style="width: 300px;margin-bottom: 70px;margin-top: 20px;">
                </div>
                
            </div> -->

                <div class="row mt-3">
                    <div class="col-sm-12">
                        <h2>Etapa 1: Capacitación</h2>
                        <p>Bienvenida a este espacio de Autoformación para el Modelo de Gestión de Calidad de la Educación Parvularia. En él podrá acceder a contenido, ejercicios prácticos y de reflexión que puede realizar de forma personal o en conjunto
                            con otros miembros del equipo de su unidad educativa. La invitamos a revisar el material de apoyo que hemos preparado, el cual ha sido agrupado en módulos temáticos.</p>

                        <br>
                        <!-- <p class="mt-2 mb-2">Además la invitamos a descargar y leer el Manual que acompaña el proceso <a (click)="verVideo('intro5')"><b style="text-decoration: underline; cursor: pointer;">Aquí</b></a>.</p> -->
                    </div>

                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="divTutoria">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="imgContainer">
                                        <img src="../../../../../assets/icons/ico_induccion.png">
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <h4>Sesión de Inducción Grupal</h4>
                                    <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse1.toggle()">6 Recursos de Apoyo</p>
                                </div>

                                <div class="col-sm-2" style="text-align: right;">
                                    <img src="../../../../../assets/icons/JUNJI__green-plus.svg" *ngIf="isCollapsed1" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample">
                                    <img src="../../../../../assets/icons/JUNJI__green-less.svg" *ngIf="!isCollapsed1" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample">
                                </div>

                                <div class="row mt-2" #collapse1="ngbCollapse" [(ngbCollapse)]="isCollapsed1">
                                    <div class="row ">
                                        <div class="col-sm-12">
                                            <p class="content">Cápsulas</p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 divContainerData">
                                            <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                            <p (click)="verVideo('intro1')" class="dataFecha docTitle">Presentación Institucional
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 divContainerData">
                                            <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                            <p (click)="verVideo('intro2')" class="dataFecha docTitle">Resumen MGCEP 7ma versión
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 divContainerData">
                                            <img src="../../../../../assets/icons/JUNJI__interactive-file_green.svg">
                                            <p (click)="verVideo('intro3')" class="dataFecha docTitle">MGCEP en el Contexto de Aseguramiento de Calidad</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <p class="content">Documentos</p>
                                        </div>
                                    </div>

                                    <div class="row ">
                                        <div class="col-sm-12 divContainerData">
                                            <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                            <p (click)="verVideo('intro4')" class="dataFecha docTitle">Ppt Inducción grupal
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 divContainerData">
                                            <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                            <p (click)="verVideo('intro5')" class="dataFecha docTitle">Manual MGCEP</p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 ">
                                            <p class="content">Enlace de Video Inducción</p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 divContainerData">
                                            <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                            <p (click)="verVideo('intro6')" class="dataFecha docTitle">Video Inducción grupal
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="divTutoria">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="imgContainer">
                                        <img src="../../../../../assets/icons/ico_reu-validacion.png">
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <h4>Módulo 3:</h4>
                                    <p class="dataFecha" style="font: normal normal bold 14px/14px Montserrat;">
                                        Autoevaluación</p>
                                    <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse4.toggle()">5 Recursos de Apoyo</p>
                                </div>

                                <div class="col-sm-2" style="text-align: right;">
                                    <img src="../../../../../assets/icons/JUNJI__green-plus.svg" *ngIf="isCollapsed4" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapse4">
                                    <img src="../../../../../assets/icons/JUNJI__green-less.svg" *ngIf="!isCollapsed4" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapse4">
                                </div>

                                <div class="row mt-2" #collapse4="ngbCollapse" [(ngbCollapse)]="isCollapsed4">
                                    <div class="row">
                                        <div class="row">

                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">Cápsulas</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p (click)="verVideo('sesion3cap2')" class="dataFecha docTitle">
                                                        Cápsula 5: Etapa Autoevaluación </p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p (click)="verVideo('sesion3cap3')" class="dataFecha docTitle">
                                                        Cápsula 6: Metodología Rúbricas</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p (click)="verVideo('sesion3cap4')" class="dataFecha docTitle">
                                                        Cápsula 7: Medios de Verificación</p>
                                                </div>
                                            </div>

                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">Documentos</p>
                                                </div>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verVideo('sesion3cap5')" class="dataFecha docTitle"> PPT Módulo 3 de Acompañamiento Personalizado </p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verVideo('sesion3cap1')" class="dataFecha docTitle"> Guía de Evaluación </p>
                                            </div>


                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">

                    <div class="col-sm-6">
                        <div class="divTutoria">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="imgContainer">
                                        <img src="../../../../../assets/icons/JUNJI__trebol-sm.svg">
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <h4>Módulo 1:</h4>
                                    <p class="dataFecha" style="font: normal normal bold 14px/14px Montserrat;">
                                        Introducción al MGCEP </p>
                                    <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse2.toggle()"> 4 Recursos de Apoyo</p>
                                </div>

                                <div class="col-sm-2" style="text-align: right;">
                                    <img src="../../../../../assets/icons/JUNJI__green-plus.svg" *ngIf="isCollapsed2" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapse2">
                                    <img src="../../../../../assets/icons/JUNJI__green-less.svg" *ngIf="!isCollapsed2" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapse2">
                                </div>

                                <div class="row mt-2" #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-6 col-md-12 col-sm-12">
                                                    <p class="content">Cápsulas</p>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__interactive-file_green.svg">
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion1cap1')">1. MGCEP: Conceptos básicos</p>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion1cap2')">2. Etapa de Capacitación</p>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion1cap3')">3. Tour Virtual</p>
                                                </div>
                                            </div>

                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">Documentos</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <!-- <a href="../../../../../assets/documentos/2021/sesion1/M1Gappd.pptx"
                                                        class="dataFecha docTitle"> PPT Sesión 1 de Acompañamiento
                                                        Personalizado</a> -->
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion1ppt1')">PPT Sesión 1 de Acompañamiento Personalizado
                                                    </p>
                                                </div>
                                            </div>

                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="divTutoria">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="imgContainer">
                                        <img src="../../../../../assets/icons/04-plan-mejora.png">
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <h4>Módulo 4:</h4>
                                    <p class="dataFecha" style="font: normal normal bold 14px/14px Montserrat;">
                                        Validación y Plan de Mejoramiento </p>
                                    <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse5.toggle()">5 Recursos de Apoyo</p>
                                </div>

                                <div class="col-sm-2" style="text-align: right;">
                                    <img src="../../../../../assets/icons/JUNJI__green-plus.svg" *ngIf="isCollapsed5" alt="avatar" style="width: 50px;margin-top: 0px;" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapse5">
                                    <img src="../../../../../assets/icons/JUNJI__green-less.svg" *ngIf="!isCollapsed5" alt="avatar" style="width: 50px;margin-top: 0px;" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapse5">
                                </div>

                                <div class="row mt-2" #collapse5="ngbCollapse" [(ngbCollapse)]="isCollapsed5">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-6 col-md-12 col-sm-12">
                                                    <p class="content">Cápsulas</p>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__interactive-file_green.svg">
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion1cap1')">1. MGCEP: Conceptos básicos</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                <p (click)="verVideo('sesion4cap1')" class="dataFecha docTitle">Cápsula 8: Etapa Validación</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                <p (click)="verVideo('sesion4cap2')" class="dataFecha docTitle">Cápsula 9: Aspectos formales de la reunión de validación</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                <p (click)="verVideo('sesion4cap3')" class="dataFecha docTitle">Cápsula 10: Etapa Plan de Mejoramiento Educativo</p>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <p class="content">Documentos</p>
                                                </div>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verVideo('sesion4cap5')" class="dataFecha docTitle"> PPT Módulo 4 de Acompañamiento Personalizado</p>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion4doc1')">Instructivo uso de zoom para entrevista de validación</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 ">
                                                    <p class="content">Actividades</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p (click)="verVideo('sesion4cap4')" class="dataFecha docTitle">
                                                        Recordando lo aprendido </p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="row">

                        <div class="col-sm-6">
                            <div class="divTutoria">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <div class="imgContainer">
                                            <img src="../../../../../assets/icons/ico_met-autoevaluacion.png">
                                        </div>
                                    </div>
                                    <div class="col-sm-8">

                                        <h4>Módulo 2:</h4>
                                        <p class="dataFecha" style="font: normal normal bold 14px/14px Montserrat;">
                                            Proyecto Educativo Institucional </p>
                                        <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse3.toggle()"> 8 Recursos de Apoyo</p>
                                    </div>

                                    <div class="col-sm-2" style="text-align: right;">
                                        <img src="../../../../../assets/icons/JUNJI__green-plus.svg" disabled *ngIf="isCollapsed3" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapse3">
                                        <img src="../../../../../assets/icons/JUNJI__green-less.svg" disabled *ngIf="!isCollapsed3" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapse3">
                                    </div>

                                    <div class="row mt-2" #collapse3="ngbCollapse" [(ngbCollapse)]="isCollapsed3">
                                        <div class="row">


                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">Cápsulas</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p (click)="verVideo('sesion2cap1')" class="dataFecha docTitle">Cápsula 4: Planificación y Mejora Continua</p>
                                                </div>
                                            </div>
                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">Documentos</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <!-- <a href="../../../../../assets/documentos/2021/sesion2/M2.pptx" class="dataFecha docTitle"> PPT Sesión 2 de Acompañamiento
                                                    Personalizado</a> -->
                                                    <p class="dataFecha docTitle" (click)="verVideo('sesion2ppt1')">PPT Sesión 2 de Acompañamiento Personalizado
                                                    </p>
                                                </div>
                                            </div>


                                            <div class="row">
                                                <div class="col-sm-12 ">
                                                    <p class="content">Actividades</p>
                                                </div>
                                            </div>


                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p (click)="verVideo('sesion2cap4')" class="dataFecha docTitle">
                                                        Orientaciones para elaborar el PEI </p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p (click)="verVideo('sesion2cap5')" class="dataFecha docTitle"> PEI Programa Jardín Clásico 2021 </p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p (click)="verVideo('sesion2cap6')" class="dataFecha docTitle"> PEI Programa Educativo Alternativo de Atención al Párvulo 2021 </p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 ">
                                                    <p class="content">Actividades</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p (click)="verVideo('sesion2cap7')" class="dataFecha docTitle">
                                                        Ejercicio: Relacionando Áreas y Dimensiones del MGCEP </p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <a href="../../../../../assets/documentos/2021/sesion2/EjercicioPEI.docx" class="dataFecha docTitle"> Ejercicio de análisis del PEI</a>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <a href="../../../../../assets/documentos/2021/sesion2/PMC.docx" class="dataFecha docTitle"> Ejercicios Proceso de Mejora
                                                    Continua</a>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-sm-6">
                            <div class="divTutoria">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <div class="imgContainer">
                                            <img src="../../../../../assets/icons/ico_books-cuanto.png">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <h4>Cuánto Aprendí</h4>
                                        <p class="dataSubGreen">Usted dispone de {{cantidadIntentos}} intento(s) para realizar la evaluación</p>
                                    </div>
                                    <!-- <div class="col-sm-4 ajusteBtn" *ngIf="cantidadIntentos>=0"> -->


                                    <div class="col-sm-4 ajusteBtn">
                                        <button (click)="comenzar()" *ngIf="!comenzarValid" class="btn btn-light btn-send">Comenzar</button>
                                        <button (click)="descargarCertificado()" *ngIf="comenzarValid" class="btn btn-light btn-send">Certificado</button>

                                    </div>
                                </div>
                                <div class="row mt-2" #collapse6="ngbCollapse" [(ngbCollapse)]="isCollapsed6">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <p class="content">Documentos</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p class="dataFecha docTitle">Documento Importante Inducción</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-12 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                    <p class="dataFecha docTitle">Marco para la Buena Enseñanza de Educación Parvulária
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">CÁPSULAS</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-6 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__interactive-file_green.svg">
                                                    <p class="dataFecha docTitle">Antecedentes del MGCEP</p>
                                                </div>
                                                <div class="col-sm-6 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__interactive-file_green.svg">
                                                    <p class="dataFecha docTitle">Otro Elemento del MGCEP</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-6 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI__video_green.svg">
                                                    <p class="dataFecha docTitle">Presentación del MGCEP</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="row">
                                                <div class="col-sm-12 ">
                                                    <p class="content">Enlace de Video LLamada</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-6 divContainerData">
                                                    <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                    <p class="dataFecha docTitle">Link de la Reunión</p>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>